import capitalize from 'lodash.capitalize';

const statusList = ['pending', 'completed', 'rejected'];

const statusOptions = statusList.map((status) => {
  return { label: capitalize(status), value: status };
});

export { statusList, statusOptions };
